import { Component, Input } from '@angular/core';

type AlertType = 'success' | 'danger' | 'info' | 'warning';

@Component({
  selector: 'ga-alert',
  template: `
    <alert [type]="type">
      <div class="d-flex align-items-center">
        <i class="fa me-2" [ngClass]="iconClass"></i>
        <span [innerHTML]="message | translate"></span>
      </div>
    </alert>
  `
})
export class GaAlertComponent {
  @Input() public type:AlertType;
  @Input() public message:string;

  public get iconClass():string {
    switch (this.type) {
      case 'success':
      case 'info':
        return 'fa-info-circle';

      case 'danger':
        return 'fa-exclamation-circle';

      case 'warning':
        return 'fa-exclamation-triangle';

      default:
        return '';
    }
  }
}